import axios from 'axios';
import { BASE_URL } from './constants';
import { User } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';

const Axios = axios.create({
  baseURL: BASE_URL,
});

Axios.interceptors.request.use((config) => {
  config.headers['X-Request-ID'] = uuidv4();
  return config;
});

let currentInterceptorId: number | undefined = undefined;

export const setOrReplaceAxiosInterceptor = (
  user?: Pick<User, 'getIdToken'>,
) => {
  if (currentInterceptorId !== undefined) {
    Axios.interceptors.request.eject(currentInterceptorId);
  }
  if (user) {
    currentInterceptorId = Axios.interceptors.request.use(
      async (config) => {
        const accessToken = await user.getIdToken();
        if (accessToken && config.headers['Authorization'] === undefined) {
          config.headers['Authorization'] = 'Bearer ' + accessToken;
        }
        return config;
      },
      (error) => Promise.reject(error),
    );
  }
};

export default Axios;
